/**
* ------------------------------------------------------------------------------------------------------------
* MODAL VIDEO FUNCTIONALITY
* ------------------------------------------------------------------------------------------------------------
*/
$(document).ready(function(){

  if ($('.video-modal-toggle').length > 0) {
   var videoURL;

   $('.modal__close-button, .modal__overlay').click(function(e) {
     e.preventDefault();
     $('.modal iframe').attr('src', '');
   });

   $('.video-modal-toggle').click(function(e) {
     videoURL = $('.modal iframe').attr('data-video-src') + '&autoplay=1';
     e.preventDefault();
     $('.modal iframe').attr('src', videoURL);
   });
  }
});
